import { Button } from "@/components/ui/button";
import { PageContainer } from "@/components/layout/PageContainer";

const ProviderCarePlanning = () => {
  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          Intelligent Care Planning
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Transform your care planning process with AI-driven insights and personalized treatment recommendations based on comprehensive patient data analysis.
        </p>
        <div className="grid gap-8 md:grid-cols-2">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Platform Features</h2>
            <ul className="space-y-3 text-gray-600">
              <li>• Data-driven care recommendations</li>
              <li>• Automated care plan generation</li>
              <li>• Treatment effectiveness tracking</li>
              <li>• Collaborative care team tools</li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Clinical Benefits</h2>
            <ul className="space-y-3 text-gray-600">
              <li>• Evidence-based decision support</li>
              <li>• Improved patient engagement</li>
              <li>• Streamlined documentation</li>
              <li>• Better care coordination</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 text-center">
          <Button size="lg" className="bg-primary hover:bg-primary/90">
            Learn More
          </Button>
        </div>
      </div>
    </PageContainer>
  );
};

export default ProviderCarePlanning;